// extracted by mini-css-extract-plugin
module.exports = {"section":"Awards_section__Z2U7y","pro_slider":"Awards_pro_slider__Z9GkB","mounted":"Awards_mounted__BK3Ij"};